module.exports = __webpack_public_path__ + "static/media/shoe-prints.b1676b0e.svg";